import React from 'react';
import { XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = ['Ves un diagrama eléctrico y no sabes por dónde empezar', 'Entiendes algunas cosas, pero dependes de otro técnico para confirmar', 'Has visto videos o cursos, pero todo se siente desordenado y sin lógica', 'Evitas trabajos con tableros o motores por miedo a equivocarte', 'Sientes que sabes "hacer cosas", pero no sabes explicar ni resolver', 'Estás cansado de teoría y necesitas algo que sí puedas aplicar en el trabajo'];
  return <section className="bg-cream py-8 px-4" data-id="element-350">
      <div className="max-w-[600px] mx-auto" data-id="element-351">
        <h2 className="text-[24px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-352">
          <AlertTriangleIcon className="w-6 h-6 text-amber-500" data-id="element-353" />
          ESTE RECURSO ES PARA TI SI…
        </h2>

        <div className="bg-brand-black-light border border-white/10 rounded-xl p-6 shadow-soft" data-id="element-354">
          <div className="space-y-5" data-id="element-355">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-356">
                <XCircleIcon className="w-6 h-6 text-danger flex-shrink-0 mt-0.5" data-id="element-357" />
                <p className="text-dark-gray text-[15px] leading-relaxed m-0" data-id="element-358">
                  {point}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}